define.alias("ember-composable-helpers/helpers/map-by", "media/helpers/map-by");